import * as types from '../constants';

export function setBreadcrumb(value) {
  return {
    type: types.SET_BREADCRUMB,
    payload: value
  }
}
